import React from "react";
import EntryContent from "../ui/EntryContent";
import Button from "../ui/Button";
import Container from "../ui/Container";
import { motion } from "framer-motion";
import SiteLink from "../ui/SiteLink";
import { StaticImage } from "gatsby-plugin-image";

const Hero = ({ data }) => {
  const { title, subtitle, cta1, cta2 } = data;

  return (
    <>
      {/* the content and the first image are stacked */}
      <Container className="relative z-10  grow pt-[16vmin] md:pt-[5vmin]">
        <div className="mx-auto max-w-screen-lg xl:max-w-screen-lg">
          <EntryContent className="text-center text-h5 prose-headings:mb-1 prose-p:mx-auto prose-p:max-w-3xl prose-p:leading-snug prose-p:text-foreground">
            <h1>{title}</h1>
            <p>{subtitle}</p>
            <div className="flex items-center justify-center gap-2">
              {cta1 && (
                <Button asChild size={"lg"}>
                  <SiteLink
                    to={cta1.link}
                    external={cta1.isExternal}
                    iconExternal={cta1.isExternal}
                  >
                    {cta1.label}
                  </SiteLink>
                </Button>
              )}
              {cta2 && (
                <Button asChild size={"lg"}>
                  <SiteLink
                    to={`${cta2.link}`}
                    external={cta2.isExternal}
                    iconExternal={cta2.isExternal}
                  >
                    {cta2.label}
                  </SiteLink>
                </Button>
              )}
            </div>
          </EntryContent>
        </div>
      </Container>
      <motion.div
        className="-mt-[20vmin] min-h-[50vh] w-full"
        initial={{
          y: 200,
        }}
        animate={{
          y: 0,
        }}
        transition={{
          duration: 5,
        }}
      >
        <StaticImage
          loading="eager"
          src="../../assets/images/homepage/hero-layer-1.png"
          width={3200}
          height={1671}
          objectFit="cover"
          objectPosition={"top"}
          className="h-full w-full"
          imgClassName="h-full w-auto object-cover object-top"
          alt=""
          quality={100}
        />
      </motion.div>
      <motion.div
        className="absolute bottom-0 left-0 min-h-[70vh] w-full object-cover object-top lg:min-h-0"
        initial={{
          y: 100,
        }}
        animate={{
          y: 0,
        }}
        transition={{
          duration: 5,
        }}
      >
        <StaticImage
          loading="eager"
          src="../../assets/images/homepage/hero-layer-2.png"
          alt=""
          placeholder="none"
          className="min-h-[70vh] w-full object-cover object-top lg:min-h-0"
          width={3200}
          height={1064}
          quality={100}
        />
      </motion.div>
      <motion.div
        className="absolute bottom-0 left-0 h-full w-full"
        initial={{
          y: 60,
        }}
        animate={{
          y: 0,
        }}
        transition={{
          duration: 5,
        }}
      >
        <StaticImage
          loading="eager"
          src="../../assets/images/homepage/hero-layer-3.png"
          alt=""
          placeholder="none"
          className="h-full w-full object-cover object-top"
          width={3200}
          height={1884}
          quality={100}
        />
      </motion.div>
    </>
  );
};

export default Hero;
